// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const CitationConfig = (translationService: any) => function(config: any) {
   const summon = { name: 'summon', label: translationService.translations.SEARCH_RESULTS_FORMAT, alternate: translationService.translations.SEARCH_RESULTS_FORMAT_ALT }

   const export_styles = [
      { name: 'refworks', label: translationService.translations.REFWORKS },
      { name: 'easybib', label: translationService.translations.EASYBIB },
      { name: 'bibliographic_software', label: translationService.translations.ENDNOTE, alias: 'endnote' },
      { name: 'bibliographic_software', label: translationService.translations.ZOTERO, alias: 'endnote' },
      { name: 'bibtex', label: translationService.translations.BIBTEX },
      { name: 'bibliographic_software', label: translationService.translations.CITAVI,  alias: 'citavi' }
   ]

   const {
      citation_formats
   } = config
   // @ts-expect-error TS(2345) FIXME: Argument of type '{ name: string; label: any; alia... Remove this comment to see the full error message
   if (config.citation_formats.citace_integration) { export_styles.push({ name: 'bibliographic_software', label: translationService.translations.CITACE_COM, alias: 'citace', url: 'https://www.citacepro.com/ris?file=' }) }

   const formats = !citation_formats.enable_refworks && citation_formats.enable_csl && citation_formats.csl_formats.length ? citation_formats.csl_formats : citation_formats.formats

   return {
      citation_styles: [summon].concat(formats),
      export_styles,
      enable_sender_email_citation: config.search_results.enable_sender_email_citation,
      require_sender_email_citation: config.search_results.require_sender_email_citation
   }
}

CitationConfig.$inject = ['translationService']

angular.module('summonApp.factories.configs')
   .factory('citationConfig', CitationConfig)
